import * as React from "react";
import { connect } from "react-redux";
import { RootState } from "../../../../store/types";
import { OrgsScreenStyle } from "./orgs-screen-style";
import { UserDataAndState } from "common/Database";
import { Mode, SignInUpModal } from "../../../modals/smart/sign-in-up-modal/sign-in-up-modal";
import OrgsSidebar from "../orgs-sidebar/orgs-sidebar";
import { LoadingIndicator } from "../orgs-styles";
import { onAuthStateChanged, isFirebaseUserSignedIn, removeOnAuthStateChanged } from "../../../../lib/firebase-auth";

interface Props {
    readonly userData: UserDataAndState;
    readonly loading: boolean;
    // You can force a starting mode for the sign up/in modal
    // If not provided, the default mode is explained in SignInUpModal
    readonly startingMode?: Mode;
    readonly includeSidebar?: boolean;
}
interface State {
    readonly firebaseAuthChangedSignal: number;
}

class OrgsScreenImpl extends React.PureComponent<React.PropsWithChildren<Props>, State> {
    public state: State = { firebaseAuthChangedSignal: 0 };

    private authStateChangedCallback = () => {
        // Well, this is all gross, but we really don't want to blink the "Sign In"
        // or "Sign Up" modals if you've already signed in but we're waiting for your
        // user data. We're only doing this to force a re-render.
        const { firebaseAuthChangedSignal } = this.state;
        this.setState({ firebaseAuthChangedSignal: firebaseAuthChangedSignal + 1 });
    };

    public componentDidMount() {
        onAuthStateChanged(this.authStateChangedCallback);
    }

    public componentWillUnmount() {
        removeOnAuthStateChanged(this.authStateChangedCallback);
    }

    private onFinish = (_cancelled: boolean) => {
        // do nothing
    };

    public render(): React.ReactNode {
        const { loading, userData, children, startingMode } = this.props;
        const includeSidebar = this.props.includeSidebar ?? true;
        if (!isFirebaseUserSignedIn() && userData === null) {
            return (
                <OrgsScreenStyle>
                    <SignInUpModal startingMode={startingMode} onFinish={this.onFinish} />
                </OrgsScreenStyle>
            );
        }

        const showLoading = loading || userData === "loading" || (isFirebaseUserSignedIn() && userData === null);

        return (
            <OrgsScreenStyle>
                {includeSidebar && <OrgsSidebar />}
                <div>{children}</div>
                {showLoading && (
                    <div className="oss-loading-overlay">
                        <LoadingIndicator />
                    </div>
                )}
            </OrgsScreenStyle>
        );
    }
}

const mapState = (state: RootState) => ({
    userData: state.userData,
});

const OrgsScreen = connect(mapState)(OrgsScreenImpl);
export default OrgsScreen;
